import { Component, HostBinding, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({ template: '' })
// tslint:disable-next-line:component-class-suffix
export abstract class GridBase implements OnInit, OnChanges, OnDestroy {
  @HostBinding('class') classList;

  classList$ = new Subject<string[]>();
  destroy$ = new Subject();

  ngOnInit(): void {
    this.classList$
      .pipe(
        takeUntil(this.destroy$),
      ).subscribe((classList: string[]) => {
      this.classList = classList.join(' ');
    });
    this.calculateClassList();
  }

  ngOnChanges(): void {
    this.calculateClassList();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  abstract calculateClassList(): void;
}
